import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 px-4 bg-brand-navy" data-id="element-1">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-2">
        {/* Who this is for */}
        <FadeIn direction="right" data-id="element-3">
          <div className="bg-brand-slate/30 border border-brand-charcoal p-8 md:p-10 rounded-3xl h-full" data-id="element-4">
            <h3 className="text-2xl font-bold text-brand-cream mb-8 flex items-center gap-3" data-id="element-5">
              <span className="w-8 h-1 bg-brand-gold rounded-full" data-id="element-6"></span>
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-7">
              {['Eres madre de un adolescente (12-18 años) y te sientes ignorada o maltratada.', 'Has perdido la alegría de estar en casa por culpa de las discusiones constantes.', 'Buscas herramientas prácticas de "aplicación hoy mismo", no teorías largas.', 'Quieres recuperar una conexión real con tu hijo antes de que se vaya de casa.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-8">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-9" />
                  <span className="text-brand-gray text-lg" data-id="element-10">{text}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        {/* Who this is NOT for */}
        <FadeIn direction="left" delay={0.2} data-id="element-11">
          <div className="bg-brand-slate/10 border border-brand-charcoal/50 p-8 md:p-10 rounded-3xl h-full opacity-80" data-id="element-12">
            <h3 className="text-2xl font-bold text-brand-cream mb-8 flex items-center gap-3" data-id="element-13">
              <span className="w-8 h-1 bg-red-500/50 rounded-full" data-id="element-14"></span>
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-15">
              {['Crees en el castigo físico o la intimidación como única solución.', 'No estás dispuesta a cambiar tu propia forma de reaccionar primero.', 'Buscas una "pastilla mágica" que cambie a tu hijo sin ningún esfuerzo de comunicación de tu parte.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-16">
                  <XCircle className="w-6 h-6 text-red-400/70 flex-shrink-0 mt-0.5" data-id="element-17" />
                  <span className="text-brand-gray/80 text-lg" data-id="element-18">{text}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}